module.exports = __webpack_public_path__ + "static/img/peopleGame.27e5769.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/hotGame/peopleGame.webp
// module id = 6ckR
// module chunks = 3